<template>
    <v-container>
        <v-row>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3">
                <v-btn x-large height="56" class="font-size-20 white--text" @click="prevPage" color="blue-grey lighten-3">{{ isFromDocManagement ? 'テンプレート管理へ戻る' : '< 戻る'}}</v-btn>
            </v-col>
            <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                <label-component fontSize="30" fontWeight="bold">
                    一括送信テンプレート概要
                </label-component>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="2" lg="2" md="2" sm="2"></v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3">
                <badge-component v-if="contractTemplate.is_official === 1" tile content="公式" color="blue">
                    <div class="font-size-20 font-weight-bold">{{ contractTemplate.template_name }}</div>
                </badge-component>
                <div v-else class="font-size-20 font-weight-bold">{{ contractTemplate.template_name }}</div>
            </v-col>
            <v-col cols="12" xl="4" lg="4" md="4" sm="4"></v-col>
        </v-row>
        <v-row class="grey lighten-3">
            <v-spacer/>
            <!-- サムネイル表示 -->
            <v-col cols="12" class="thumb_wrap text-center" v-for="(dbFile, index) in dbFileList" :key="`1st-${index}`">
                <div class="thumb" v-show="dbFile.id" @click="toPdfPreview(dbFile.objectId)">
                    <v-icon class="plus-icon" color="white">mdi-magnify</v-icon>
                    <pdf-thumb-component v-show="dbFile.id" :pdfData="dbFile.pdfData" :scale="1" max-width="196px" :suffixes="index"></pdf-thumb-component>
                </div>
                <div v-show="dbFile.id">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <span
                            class="info-to font-size-1-5rem"
                            v-bind="attrs"
                            v-on="on"
                            
                            >
                                {{ dbFile.pdfName | omittedText30 }}
                            </span>
                        </template>
                        <span>{{ dbFile.pdfName }}</span>
                    </v-tooltip>

                </div>
            </v-col>
            <v-spacer/>
        </v-row>
        <v-row justify="center">
            <v-col cols="10">
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <!-- ワークフロー表示 -->
                <template-overview-workflow-component :items="destinationList" :user="user"></template-overview-workflow-component>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="text-center">
                <v-btn v-if="!isFromDocManagement" class="font-size-20 white--text" color="red" @click="use">使用する</v-btn>
                <!-- テンプレート管理から遷移 オリジナルテンプレートの場合　公式テンプレートの場合はボタンは表示しない  -->
                <v-btn v-else-if="(contractTemplate.is_official === 0) && isFromDocManagement" class="font-size-20 white--text" color="blue" @click="edit">編集する</v-btn>
            </v-col>
        </v-row>
        
        <!-- メッセージ -->
        <message-component id="message" v-model="isMessage" :success="message.success">{{ message.text }}</message-component>
    </v-container>
</template>
<script>
  export default {
    props: {
        user: Object,
        uid: String,
        contractTemplate: Object,
        destinationList: Array,         // 契約送付先リスト
        dbFileList: Array,              // ファイルリスト
        isFromDocManagement: false,     // テンプレート管理画面からの遷移
    },
    data() {
        return {
            new_uid: '',
            message: {
                success: false,
                text: "",
            }
        };
    },
    computed: {
        isMessage: {
            get() {
                return this.message.text != '';
            },
            set(value) {
                if (!value) {
                    this.message.text = '';
                }
            }
        },
    },
    filters: {
        omittedText(text) {
         // 11文字目以降は"…"
         return text.length > 10 ? text.slice(0, 10) + "…" : text;
        },
        omittedText30(text) {
         // 20文字目以降は"…"
         return text.length > 30 ? text.slice(0, 30) + "…" : text;
        }
    },
    methods: {
        // 遷移元に戻る
        prevPage() {
            if (this.isFromDocManagement) {
                window.location.href = "/documents/document-management/template";
            } else {
                window.location.href = "/documents/multiple-send/template";
            }
        },
        // 編集
        edit() {
            window.location = "/documents/document-management/multiple-send-template/" + this.uid + "/info";
        },
        // pdfプレビュー画面へ
        toPdfPreview: function(objectId) {
            // 別タブで開く
            window.open("/documents/document-management/template/" + this.uid + "/pdf-preview/" + objectId, '_blank');
        },
        use: function () {
            if (this.uid != null && this.uid.length) {
                window.location = '/documents/multiple-send/' + this.uid + "/confirm";
            }
        },
    },
  };
</script>

<style scoped>
    .font-size-20 {
        font-size: 20px;
    }
    .font-weight-bold {
        font-weight: bold;
    }
    .margin-top-30 {
        margin-top: 30px;
    }
    .thumb_wrap {
        width:240px;
        max-width: 240px;
    }
    .plus-icon {
        cursor : pointer;
        opacity: 0;
        position: absolute;
        z-index:99;
        background-color:rgba(0,0,0,0.4);
        border-radius: 50%;
        top: 120px;
        left: 90px;
    }
    .thumb {
        cursor : pointer;
        font-size: 14px;
        margin-left: 20px;
        position: relative;
    }
    .thumb:hover .plus-icon{
        opacity: 1;
        transform: scale(2, 2);
    }
    .font-size-1-5rem{
        font-size:1.5rem;
    }
</style>

